export default "__VITE_ASSET__qsHsbSxB__"